import { useEffect } from "react";
import { useGetProducts } from "../../api/get-products";
import { getInitialPreparedCart, selectPreparedCartCatalogProducts } from "../../store/prepared-cart";
import { useCartState } from "../../store/use-cart-state";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { configName } from "../config/config-name";

export const usePrefillFromPreparedCart = () => {
  const { isCreatedFromRecommendation, addPurchaseCatalogProduct, setIsCreatedFromRecommendation } = useCartState();
  const { voucherDistribution } = useVouchersDistributionState();
  const slug = voucherDistribution?.slug ?? "";

  const productsQuery = useGetProducts({ slug, configName });
  const catalogProducts = productsQuery.data?.products;

  useEffect(() => {
    const preparedCart = getInitialPreparedCart();

    if (!preparedCart || isCreatedFromRecommendation) return;
    if (!slug || preparedCart.slug !== slug) return;
    if (!catalogProducts) return;

    for (const product of selectPreparedCartCatalogProducts(catalogProducts, preparedCart)) {
      addPurchaseCatalogProduct(product);
    }

    setIsCreatedFromRecommendation(true);
  }, [slug, catalogProducts, isCreatedFromRecommendation, addPurchaseCatalogProduct, setIsCreatedFromRecommendation]);
};
